import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import {
  BUILD_VERSION,
  GU_UIKIT_VERSION,
  LOCALISATION_VERSION,
  UQ_UIKIT_VERSION
} from "@util/config";
import App from "./component/App";
import store from "./redux/store";
import DynamicComponent from "./component/common/DynamicComponent";

(window as any).__BUILD_VERSION__ = BUILD_VERSION;
(window as any).__LOCALISATION_VERSION__ = LOCALISATION_VERSION;
(window as any).__UQ_UIKIT_VERSION__ = UQ_UIKIT_VERSION;
(window as any).__GU_UIKIT_VERSION__ = GU_UIKIT_VERSION;

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Provider store={store}>
    <Suspense fallback={<div />}>
      <HelmetProvider>
        <DynamicComponent>
          <Router>
            <Routes>
              <Route path={":region/:language/*"} element={<App />} />
            </Routes>
          </Router>
        </DynamicComponent>
      </HelmetProvider>
    </Suspense>
  </Provider>
);
